import React from 'react'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'
import { CollectionAsset, CollectionInfoBoxDescription } from 'meta/pages/collection'

import Desktop from './Desktop'
import Mobile from './Mobile'

interface Props {
  images: CollectionAsset[]
  setVisible(num: number): void
  descData: CollectionInfoBoxDescription
}

const Images: React.FC<Props> = (props) => {
  const { images, setVisible, descData } = props

  return (
    <>
      <MediaQuery maxWidth={BreakpointsMaxWidth.tablet}>
        <Mobile images={images} setVisible={setVisible} descData={descData} />
      </MediaQuery>
      <MediaQuery minWidth={BreakpointsMaxWidth.tablet}>
        <Desktop images={images} setVisible={setVisible} descData={descData} />
      </MediaQuery>
    </>
  )
}

export default Images
